<template>
  <div class="cell-wrapper" 
       :class="{'clickable': clickable}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ChecklistTableTaskCellWrapper',
  props: {
    clickable: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.cell-wrapper {
  border: get-border(transparent);
  @include border-radius('border-radius-3');
  height: 100%;
  padding: 8px 12px;
  transition: border-color 0.2s ease-in-out;

  &.clickable:hover {
    border-color: rgb(var(--v-theme-border-primary));
  }
}
</style>
